import 'babel-polyfill';
import 'formdata-polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { initialize, addTranslationForLanguage } from 'react-localize-redux';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-theme.css';
import 'react-responsive-modal/styles.css';
import 'font-awesome/css/font-awesome.min.css';

import localizationFi from './localization/fi.json';
import localizationEn from './localization/en.json';

import './fonts.css';
import './index.css';

import App from './App';
import store, { browserHistory } from './store';

const languages = {
  fi: localizationFi,
  en: localizationEn,
};

store.dispatch(initialize(Object.keys(languages), { defaultLanguage: 'fi' }));

for (const language in languages) {
  store.dispatch(addTranslationForLanguage(languages[language], language));
}

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={browserHistory}>
      <App />
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root'),
);
